import { render } from "./EditContractProposalPage.vue?vue&type=template&id=529bc268"
import script from "./EditContractProposalPage.vue?vue&type=script&lang=js"
export * from "./EditContractProposalPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__